import useAuth from '../../auth/authContext';
import { useMemo } from 'react';

export type Feature = 'pay-all';

const SALT = '2c87f30e-0742-4237-8291-fff6e25f2ff5';

const hashCode = (str: string) => {
  let hash = 0;
  if (str.length === 0) return hash;
  for (let i = 0; i < str.length; i++) {
    const chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
};

export const useGradualRollout = (
  feature: Feature,
  rolloutLevel: number
): { isEnabled: boolean } => {
  const {
    state: { user },
  } = useAuth();

  const userLevel = useMemo(
    () => Math.abs(hashCode(`${user?.email ?? ''}-${feature}-${SALT}`)) % 100,
    [user?.email, feature]
  );
  if (!user) return { isEnabled: false };
  return { isEnabled: userLevel < rolloutLevel };
};
